export default {
    COMPLIANCE: 'compliance',
    MARKETPLACE: 'marketplace',
    PLAYBOOK: 'playbook',
    ASSESSMENT: 'assessment',
    EVIDENCE_LOCKER: 'evidence-locker',
    TRAINING: 'training'
}


// WEBPACK FOOTER //
// ./src/utils/moduleMapping.js